import { createSelector } from 'reselect';
import Immutable from 'immutable';

import { selectUGCListByUsers } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'similarTitlesTransactions'], Immutable.Map());

export const selectSimilarTitlesByUsers = selectUGCListByUsers('similarTitles');

export const selectSimilarTitlesTransactions = createSelector([getTransactions], transactions => transactions);

export default {
  selectSimilarTitlesByUsers,
  selectSimilarTitlesTransactions
};
